export default __webpack_public_path__ + "static/contact-full-dd0cd6c3b877e136e13ed2ed91dbb2c6.jpg";